<template>
  <vs-popup
    :title="
      'Add guest list entry for ' +
      activeVenue.name +
      ' on ' +
      formatPopupDate()
    "
    @close="handleOnClose"
    :active.sync="showThisPopup"
    :accept-text="'Add guest'"
    :is-valid="validForm"
    class="add-guest-list-item-popup"
  >
    <div v-if="guestListItem" class="add-guest-list-item-popup-content">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Search for guest</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <v-suggest
            :data="
              guestProfiles.length > 0
                ? guestProfiles
                : guestStatistics.latestGuests
            "
            @values="selectedGuest"
            :show-field="showField"
            autocomplete="off"
            v-model="query"
          >
            <!-- scoped slot -->
            <template #default="{ row }">
              <div>
                <strong v-text="row.email"></strong>
              </div>
              <div
                class="text-muted"
                v-text="row.firstName + ' ' + row.lastName"
              ></div> </template
          ></v-suggest>
        </div>
      </div>
      <vs-divider />
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Full name</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            v-model="guestListItem.fullName"
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Email</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            type="email"
            class="w-full"
            icon-pack="feather"
            icon="icon-mail"
            icon-no-border
            :warning="!validateEmail(guestListItem.email)"
            warning-text="E-mail not valid"
            v-model="guestListItem.email"
          />
          <p v-if="!guestListItem.guestProfileId && guestListItem.email">
            A new guest profile will be created
          </p>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Phone number</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-smartphone"
            type="phone"
            :warning="!validatePhone(guestListItem.phoneNumber)"
            warning-text="Phone not valid"
            icon-no-border
            v-model="guestListItem.phoneNumber"
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Number of guests</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input-number v-model="guestListItem.guestCount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Note</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-textarea
            class="w-full"
            icon-pack="feather"
            icon="icon-lock"
            icon-no-border
            v-model="guestListItem.note"
            placeholder="Add a note"
          >
          </vs-textarea>
        </div>
      </div>
    </div>
    <vs-divider />
    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        class="mr-2"
        color="primary"
        :disabled="!validForm"
        @click="handleSaveClick"
        >Add guest</vs-button
      >
      <vs-button type="border" color="primary" @click="handleOnClose"
        >Cancel</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import moment from "moment";
import { GuestListItem } from "@/store/modules/marcom/data-model/guest-list-items/guest-list-item";
import validators from "@/views/mixins/validators";
import { Suggest } from "v-suggest";

export default {
  mixins: [validators],
  components: {
    "v-suggest": Suggest,
  },
  data() {
    return {
      showThisPopup: false,
      guestListItem: undefined,
      isSearchingGuestByEmail: false,
      guestFound: false,
      searchCount: 0,
      myValue: "",
      query: "",
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueDetails: "marcom/activeVenue",
      guestProfiles: "guestProfiles/queryResult",
      guestStatistics: "guestProfiles/guestStatistics",
    }),
    validForm() {
      return this.guestListItem && this.guestListItem.isValid();
    },
  },
  methods: {
    showField(row) {
      return row.email + " " + row.firstName + " " + row.lastName;
    },
    selectedGuest(g) {
      this.guestListItem.guestProfileId = g.id;
      this.guestListItem.fullName = g.firstName + " " + g.lastName;
      this.guestListItem.email = g.email;
      this.guestListItem.phoneNumber = g.phone ? g.phone : "";
    },
    show(date) {
      const utcDate = moment.utc(date.format("YYYY-MM-DD")).toJSON();
      this.guestListItem = new GuestListItem(
        utcDate,
        this.activeVenueDetails.venueDetailsId
      );
      this.showThisPopup = true;
    },
    async onSearch() {
      if (this.query == "") {
        await this.$store.dispatch("guestProfiles/clearQuery");
        this.guestListItem.guestProfileId = undefined;
      } else {
        //this.$vs.loading();
        await this.$store.dispatch("guestProfiles/queryGuests", this.query);
        //this.$vs.loading.close();
      }
    },

    async handleSaveClick() {
      try {
        this.$vs.loading();

        await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.AddGuestListItem,
          this.guestListItem
        );

        this.handleOnClose();
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.$vs.loading.close();
      }
    },
    handleOnClose() {
      this.guestListItem = undefined;
      this.showThisPopup = false;
    },
    formatPopupDate() {
      if (this.guestListItem) {
        let noteMoment = moment.utc(this.guestListItem.date);
        if (!noteMoment.isValid()) return undefined;
        return noteMoment.format("DD-MM-YYYY");
      }
      return undefined;
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("guestProfiles/getStatistics");
    this.$vs.loading.close();
  },
  watch: {
    // For lack of event by v-suggest
    query(newVal, oldVal) {
      this.onSearch(newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-guest-list-item-popup::v-deep .vs-popup {
  width: 650px;
}
</style>


<style lang="scss">
.v-dropdown-container {
  z-index: 999999 !important;
}
</style>